import { EditorState, HISTORY_ACTION_MODE, useEditor } from '@candulabs/craft';
import { useEffect } from 'react';

export const useFormStepsSuccessNormalization = (id: string) => {
  const { query, actions } = useEditor();
  const children = query.node(id).childNodes();

  useEffect(() => {
    const numberOfChildren = children.length;
    if (numberOfChildren < 2) {
      return;
    }
    const nodes = children.map((nid) => query.node(nid).get());
    const lastChildIndex = children.length - 1;
    const successFormStepIndex = nodes.findIndex((n) => n?.data?.props?.type === 'success');
    if (successFormStepIndex === lastChildIndex) {
      return;
    }
    actions.produceState((editorState: EditorState) => {
      const newNodes = [...children, children[successFormStepIndex]];
      newNodes.splice(successFormStepIndex, 1);
      // eslint-disable-next-line no-param-reassign
      editorState.nodes[id].data.nodes = newNodes;
    }, HISTORY_ACTION_MODE.IGNORE);
  }, [children]);
};
